import React from 'react';

import PropTypes from 'prop-types';

import { Glyphicon } from 'reaxl';

function SearchInput({
    className = '',
    placeholder = 'Ask Anything',
    'aria-label': ariaLabel,
    'data-cmp': dataCmp = 'search-input',
    ...rest
}) {
    return (
        <div
            className={`autocomplete-search padding-0 display-flex align-items-center justify-content-between ${className}`}
        >
            <Glyphicon
                glyph="ai-search"
                className="text-accent padding-3 text-size-500"
                style={{ position: 'relative', marginRight: -48, zIndex: 1 }}
            />
            <div className="flex-grow react-autosuggest__container autocomplete">
                <input
                    type="text"
                    className="form-control"
                    data-cmp={dataCmp}
                    aria-autocomplete="list"
                    placeholder={placeholder}
                    aria-label={ariaLabel || placeholder}
                    {...rest}
                />
            </div>
        </div>
    );
}

SearchInput.propTypes = {
    /**
     * Additional CSS classes to apply to the container
     */
    className: PropTypes.string,
    /**
     * Placeholder text for the input
     */
    placeholder: PropTypes.string,
    /**
     * Aria label for accessibility
     */
    'aria-label': PropTypes.string,
    /**
     * Data component identifier for tracking
     */
    'data-cmp': PropTypes.string,
};

export default SearchInput;
